var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.1 187.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 0,
    y1: 93.55,
    x2: 187.1,
    y2: 93.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006496"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.55,187.1C41.97,187.1,0,145.14,0,93.55S41.97,0,93.55,0s93.55,41.97,93.55,93.55-41.97,93.55-93.55,93.55Zm0-178.76C46.57,8.34,8.34,46.57,8.34,93.55s38.22,85.21,85.21,85.21,85.21-38.22,85.21-85.21S140.54,8.34,93.55,8.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 92.17,
    cy: 50.98,
    r: 5.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.08,127.18h-7.27v-56.42c0-3.2-2.62-5.82-5.82-5.82h-6.54c-1.45,0-2.62,1.16-2.62,2.62s1.16,2.62,2.62,2.62h6.54c.44,0,.73,.29,.73,.73v56.28h-7.27c-1.45,0-2.62,1.16-2.62,2.62s1.16,2.62,2.62,2.62h19.63c1.45,0,2.62-1.16,2.62-2.62s-1.16-2.62-2.62-2.62Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.77f092618b01451d5bc5997994a6db0e.svg";
export { ForwardRef as ReactComponent };